export enum OddsDisplay {
  Decimal = 'DECIMAL',
  American = 'AMERICAN',
  Fractional = 'FRACTIONAL',
}
